import { useEffect, useState } from 'react'
import { Table, Space, Pagination, Input, Col, Row, Divider, Checkbox, Button } from 'antd'
import { isEmpty, size, trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import {
   CONFIG_URL,
   DATE_TIME_FORMAT_CLIENT_short2,
   PAGE_SIZE,
   ROLES,
   STATUS_ACTIVITY,
   getPage,
   getStatusText
} from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import useWindowDimensions from '../../common/useWindowDimensions'
import moment from 'moment'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { formatCurrency } from 'src/helpers/functions'
import useModal from 'src/helpers/modal/useModal'
import Create from './Create'
import DetailProductGroup from './DetailProductGroup'
import ImagePreview, { getImageUrl } from 'src/common/components/ImagePreview'

const ProductsManagement = observer((props: any) => {
   const { t } = useTranslation()
   const ProductStore = useStore('ProductStore')
   const JobDetailStore = useStore('JobDetailStore')
   // const CommonConfigStore = useStore('CommonConfigStore')
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   // const { designTypesList, productTypesList } = CommonConfigStore
   const [visible, setVisible] = useState(false)
   const [textSearch, set_textSearch] = useState('')
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   // const [isLoading, setIsLoading] = useState(false)
   const { height } = useWindowDimensions()
   const [visibleCreate, setVisibleCreate] = useState(false)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [item, setItem] = useState(null)
   const [fieldFilter, setFieldFilter] = useState<any>({})
   const [statusObj, setStatusObj] = useState<any>({
      new: [STATUS_ACTIVITY.NEW],
      doing: [STATUS_ACTIVITY.DOING],
      review: '',
      finish: '',
      reject: [STATUS_ACTIVITY.REJECT]
   })
   const { jobTotal } = ProductStore
   const { rows, offset, count } = ProductStore.productGroups
   const [isOpenEditJobDetail, setIsOpenEditJobDetail] = useState(false)
   const [selectedItem, setSelectedItem] = useState<any>([])

   const [visibleAssign, setVisibleAssign] = useState<any>(false)
   const [itemUser, setItemUser] = useState<any>(null)
   const [itemDesigner, setItemDesigner] = useState(null)
   const [itemCreator, setItemCreator] = useState(null)
   const [visibleUserDetailCreator, setVisibleUserDetailCreator] = useState<any>(false)
   const [visibleUserDetailDesigner, setVisibleUserDetailDesigner] = useState<any>(false)
   const { confirm } = useModal()

   useEffect(() => {
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(0, {
         ...fieldFilter,
         ...{ search: trim(textSearch) }
         // ...{ status: statusResult }
      })
      // JobsStore.getJobTotal(statusResult)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch])

   const onSubmitFilter = (value: any) => {
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()
      // console.log('statusNow: ', statusObj, 'statusResult; ', statusResult)
      // setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
      setFieldFilter({
         ...fieldFilter,
         ...value
         // ...{ status: statusResult }
      })
      getListData(0, {
         ...fieldFilter,
         ...{ name: trim(textSearch) },
         ...value
         //  ...{ status: statusResult }
      })
   }

   const onResetFilter = () => {
      const page = 0
      setFieldFilter({})
      getListData(0, { ...{ search: trim(textSearch) } })
   }

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage, PAGE_SIZE)
         const params = { offset, ...param }

         await ProductStore.getProductGroup(params)
      } catch (error) {
         // console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      // console.log('currentPage;', currentPage, 'currentPage-1', currentPage - 1)
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(currentPage - 1, {
         ...fieldFilter,
         ...{ search: trim(textSearch) } // ...{ status: statusResult }
      })
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   const handleShowDetail = (item: any) => {
      setItem(item)
      // JobDetailStore.setJobDetail(item)
      setVisibleDetail(true)
   }

   const handleAssignJob = (item: any) => {
      setSelectedItem(item)
      JobDetailStore.setJobDetail(item)
      setVisibleAssign(true)
   }

   const handleCloseAssign = () => {
      setVisibleAssign(false)
   }
   const openEditJobModal = () => {
      setIsOpenEditJobDetail(true)
   }

   const closeEditJobModal = () => {
      setIsOpenEditJobDetail(false)
   }

   const onChangeStatus = (key: string | number, e: any) => {
      // let notOrder = OrderStore.optionSearchOrderCustomer.status.includes(1) ? [1] : []
      // let placingData = OrderStore.optionSearchOrderCustomer.status.includes(2) ? [2] : []
      // let orderFinish = OrderStore.optionSearchOrderCustomer.status.includes(3) ? [3] : []
      // let soldOut = OrderStore.optionSearchOrderCustomer.status.includes(4) ? [4] : []
      let statusNow = { ...statusObj }
      switch (key) {
         case STATUS_ACTIVITY.NEW:
            if (e.target.checked) {
               statusNow.new = [STATUS_ACTIVITY.NEW]
            } else {
               statusNow.new = []
            }
            break
         case STATUS_ACTIVITY.DOING:
            if (e.target.checked) {
               statusNow.doing = [STATUS_ACTIVITY.DOING]
            } else {
               statusNow.doing = []
            }
            break
         case STATUS_ACTIVITY.REVIEW:
            if (e.target.checked) {
               statusNow.review = [STATUS_ACTIVITY.REVIEW]
            } else {
               statusNow.review = []
            }
            break
         case STATUS_ACTIVITY.REJECT:
            if (e.target.checked) {
               statusNow.reject = [STATUS_ACTIVITY.REJECT]
            } else {
               statusNow.reject = []
            }
            break
         default:
            if (e.target.checked) {
               statusNow.finish = [STATUS_ACTIVITY.FINISH]
            } else {
               statusNow.finish = []
            }
            break
      }
      setStatusObj(statusNow)
      // let dataStatus = [...placingData, ...notOrder, ...orderFinish, ...soldOut]
      // OrderStore.setOptionSearchOrderCustomer({ status: dataStatus })

      const statusResult = [
         ...statusNow.new,
         ...statusNow.doing,
         ...statusNow.review,
         ...statusNow.reject,
         ...statusNow.finish
      ].toString()
      // console.log('statusNow: ', statusNow, 'statusResult; ', statusResult)
      setFieldFilter({
         ...fieldFilter
         // ...{ status: statusResult }
      })
      getListData(0, {
         ...fieldFilter,
         ...{ search: trim(textSearch) } //...{ status: statusResult }
      })
   }

   const handleShowEdit = (item: any) => {
      setItem(item)
      setVisibleCreate(true)
   }

   const handleDeleteProductGroup = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonxoabanghi),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await ProductStore.deleteProductGroup(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ search: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }

   const handleCreate = () => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ search: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      setVisibleCreate(false)
      setItem(null)
   }
   const handleEdit = () => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ search: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      setVisibleDetail(false)
      setItem(null)
   }

   let columns = [
      {
         title: 'ID',
         dataIndex: 'id',
         key: 'id',
         width: 50,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: 'Tên',
         dataIndex: 'name',
         key: 'name',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: t(GLOBAL_CLIENT.txtDateTime),
         dataIndex: 'createdAt',
         key: 'createdAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: 'Cập nhật cuối',
         dataIndex: 'updatedAt',
         key: 'updatedAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.image),
         dataIndex: 'images',
         width: 80,
         key: 'images',
         render: (value: any) => {
            return value ? (
               <ImagePreview src={getImageUrl(value, CONFIG_URL.IMAGE_URL)} size={64} fit="contain" />
            ) : (
               <></>
            )
         }
      },

      {
         title: 'Trạng thái',
         dataIndex: 'status',
         width: 80,
         key: 'status',
         render: (value: boolean) => {
            return (
               <Checkbox disabled defaultChecked={value}>
                  {t(value ? GLOBAL_CLIENT.active : GLOBAL_CLIENT.inactive)}
               </Checkbox>
            )
         }
      }
   ]

   const col3 = [
      {
         title: 'Action',
         key: 'action',
         width: 110,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (text: string, record: any, index: number) => {
            return (
               <span className="txtMax2Line">
                  {/* {record?.status === STATUS_ACTIVITY.NEW && <AssignJob detail={record} indexItem={index} />} */}
                  <span onClick={() => handleShowDetail(record)} className="gx-link txtMax2LineHover">
                     {t(GLOBAL_CLIENT.detail)}
                  </span>
                  <>
                     <Divider type="vertical" />
                     <span onClick={() => handleShowEdit(record)} className="gx-link txtMax2LineHover">
                        {t(GLOBAL_CLIENT.edit)}
                     </span>
                  </>
                  <>
                     <Divider type="vertical" />
                     <span onClick={() => handleDeleteProductGroup(record)} className="gx-link txtMax2LineHover">
                        {t(GLOBAL_CLIENT.delete)}
                     </span>
                  </>
               </span>
            )
         }
      }
   ]
   const hideCreate = () => {
      setVisibleCreate(false)
      setItem(null)
   }
   const hideDetail = () => {
      setVisibleDetail(false)
      setItem(null)
   }
   const showCreate = () => {
      setVisibleCreate(true)
   }

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   return (
      <>
         {/* <Loading isLoading={isLoading} /> */}
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={8}>
                     <Input.Search
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.search)}
                        allowClear
                        enterButton
                     />
                  </Col>
                  <Col xs={24} md={2}>
                     {/* <Button type="primary" className="btn-add" onClick={handleFilter}>
                        <i className="icon icon-filter icon-in-button" />
                        {t(GLOBAL_CLIENT.filter)}
                     </Button> */}
                     {/* <Filter onSubmitFilter={onSubmitFilter} onResetFilter={onResetFilter} /> */}
                  </Col>
                  {/* <Col xs={24} md={12}>
                     <Input.Search onSearch={handleChangeTextSearch} placeholder={t(GLOBAL_CLIENT.search)} allowClear />
                  </Col> */}
                  <Col xs={24} md={14}>
                     <div className="text-right">
                        <Space>
                           <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />

                              {t(GLOBAL_CLIENT.create)}
                           </Button>
                        </Space>
                     </div>
                  </Col>
               </Row>
               <Space
                  className="total-items"
                  style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
               >
                  <div>
                     {t(GLOBAL_CLIENT.totalItems)}: {count}
                  </div>
               </Space>

               <Table
                  scroll={{ x: 1500, y: height - 280 }}
                  columns={[...columns, ...col3]}
                  dataSource={rows}
                  rowKey="id"
                  pagination={false}
               />

               {renderPagination()}
            </Col>
         </Row>

         {visibleCreate && <Create visible={visibleCreate} item={item} onOk={handleCreate} onCancel={hideCreate} />}
         {visibleDetail && item && (
            <DetailProductGroup visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />
         )}
      </>
   )
})

export default ProductsManagement
